/* eslint-disable jsx-a11y/anchor-is-valid */
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon, DownloadIcon, XIcon } from "@heroicons/react/solid";
import { FolderIcon } from "@heroicons/react/solid";
import axios from "axios";
import React, { Fragment, useCallback, useContext } from "react";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { CopyBlock, monoBlue } from "react-code-blocks";
import "react-h5-audio-player/lib/styles.css";
import ReactPlayer from "react-player";
import ImageViewer from "react-simple-image-viewer";
import moment from "moment";
import { ClockLoader } from "react-spinners";
import useDownloader from "react-use-downloader";
import useState from "react-usestateref";
import TimeAgo from "timeago-react";
import backendService from "../services.js/backendService";
import { SocketContext } from "../services.js/socket";
import ForwardMessageModal from "./ForwardMessageModal";
import RunCodeModal from "./RunCodeModal";
import EditCodeModal from "./EditCodeModal";
import ConfirmationDialogBox from "./ConfirmationDialogBox";
import { toast } from "react-toastify";
import {
  languages,
  getCompilerCodeByExtension,
  isExtensionCodeFile,
  urlToBlob,
  blobToString,
} from "./CodingLanguageList";
import ViewCodeModal from "./ViewCodeModal";
import {
  initializeFileTypeIcons,
  getFileTypeIconProps,
} from "@fluentui/react-file-type-icons";
import { Icon } from "@fluentui/react/lib/Icon";
import { EyeIcon, PlayIcon } from "@heroicons/react/outline";
const optimizeURL = (URL) => {
  const parametre = "upload/q_auto:best";
  return URL.replace("upload", parametre);
};


function truncate(string, n) {
  return string?.length > n ? string.substr(0, n - 1) + "..." : string;
}

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function ChatBubble(props) {
  const { size, elapsed, percentage, download, cancel, error, isInProgress } =
    useDownloader();
  const [hovered, setHovered] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const [showCodeRunModal, setShowCodeRunModal] = useState(false);
  const [openViewCodeModal, setOpenViewCodeModal] = useState(false);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [codeData, setCodeData, codeDataRef] = useState(null);
  const [isHovering, setIsHovering] = useState(false);
  const [chevronIcon, setChevronIcon] = useState(false);
  const [forwardMessage, setForwardMessage] = useState(false);
  const [currentMessage, setCurrentMessage, currentMessageRef] = useState(null);
  const [editCode, setEditCode] = useState(false);
  const [deleteMessageAlert, setDeleteMessageAlert] = useState(false);
  const socket = useContext(SocketContext);
  //
  const openImageViewer = useCallback(() => {
    setIsViewerOpen(true);
  }, []);

  const deleteMessage = async (id) => {
    try {
      const res = await axios.delete(`${process.env.REACT_APP_URL}/deletemessage/${id}`, {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": backendService.getToken(),
        },
      });
      socket.emit("deleteMessage", {
        receiverId: props.reciever,
        messageId: id,
      });
      props.getForwardMessage(res);
      props.getDeleteMessage(id);
      alert(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  const findUserById = (id) => {
    const user = props.userInfo.participants.find((user) => user._id === id);
    return user;
  };
  const openCodeRunModal = (data) => {
    setShowCodeRunModal(data);
   
  };

  const closeImageViewer = () => {
    setIsViewerOpen(false);
  };

  const codeRunModal = () => {
   
    return (
      <RunCodeModal
        openCodeRunModal={openCodeRunModal}
        codeData={codeDataRef.current}
      />
    );
  };

  const openForwardMessageModal = (data) => {
    setForwardMessage(data);

  };
  const forwardMessageModal = () => {
    return (
      <ForwardMessageModal
        openForwardMessageModal={openForwardMessageModal}
        messageId={currentMessageRef.current}
        getForwardMessage={props.getForwardMessage}
      />
    );
  };

  const openEditCodeModal = (data) => {
    setEditCode(data);
  };

  const editCodeModal = () => {
    return (
      <EditCodeModal
        openEditCodeModal={openEditCodeModal}
        codeData={props.message}
        getEditMessage={props.getEditMessage}
      />
    );
  };

  const openDeleteMessageAlert = (data) => {
    setDeleteMessageAlert(data);
  };

  const deleteMessageConfirmationAlert = () => {
    return (
      <ConfirmationDialogBox
        openDeleteMessageAlert={openDeleteMessageAlert}
        getDeleteMessage={props.getDeleteMessage}
        getForwardMessage={props.getForwardMessage}
        reciever={props.reciever}
        id={props.message._id}
      />
    );
  };

  const viewCodeModel = () => {
    return (
      <ViewCodeModal
        openViewCodeModal={setOpenViewCodeModal}
        codeData={codeDataRef.current}
      />
    );
  };

  return (
    <>
      {isViewerOpen && (
        <ImageViewer
          src={[props.message?.data.filePath]}
          currentIndex={0}
          onClose={closeImageViewer}
          backgroundStyle={{
            backgroundColor: "rgba(0,0,0,0.9)",
            zIndex: "50",
          }}
        />
      )}

      {showCodeRunModal && codeRunModal()}
      {forwardMessage && forwardMessageModal()}
      {editCode && editCodeModal()}
      {deleteMessageAlert && deleteMessageConfirmationAlert()}
      {openViewCodeModal && viewCodeModel()}
      <div className="flex flex-col px-3">
        {props.message.contentType === "text" ? (
          <div
            className="inline-grid auto-rows-auto relative"
            onMouseEnter={() => setChevronIcon(true)}
            onMouseLeave={() => setChevronIcon(false)}
          >
            <div
              className={classNames(
                props.message.senderId !==
                  backendService.getLoggedInUser()["_id"]
                  ? "flex-row-reverse"
                  : null,
                "flex  items-center"
              )}
            >
              {chevronIcon && (
                <div
                  className={classNames(
                    props.message.senderId !==
                      backendService.getLoggedInUser()["_id"]
                      ? "justify-between "
                      : "justify-end mx-4",
                    "relative flex items-center justify-center"
                  )}
                >
                  <Menu
                    as="div"
                    className="absolute items-center justify-center inline-block text-left"
                  >
                    <Menu.Button>
                      <ChevronDownIcon
                        className="h-6 w-6 text-palette_color1 cursor-pointer"
                        aria-hidden="true"
                      />
                    </Menu.Button>

                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items
                        className={classNames(
                          props.message.senderId !==
                            backendService.getLoggedInUser()["_id"]
                            ? "left-0"
                            : "right-0",

                          "origin-top-center absolute  bottom-[30px] mt-1 w-48 rounded-md shadow-sm shadow-black bg-palette_color2 focus:outline-none z-10"
                        )}
                      >
                        <Menu.Item>
                          {({ active }) => (
                            <a
                              href="#"
                              className={classNames(
                                active
                                  ? "bg-palette_color1 text-palette_color2 rounded-t-md"
                                  : "text-palette_color1",
                                "block px-4 py-2 text-sm font-robo "
                              )}
                              onClick={() => {
                                setCurrentMessage(props.message._id);
                                setForwardMessage(true);
                              }}
                            >
                              Forward Message
                            </a>
                          )}
                        </Menu.Item>
                        {props.message.senderId !==
                        backendService.getLoggedInUser()["_id"] ? null : (
                          <Menu.Item>
                            {({ active }) => (
                              <a
                                href="#"
                                className={classNames(
                                  active
                                    ? "bg-palette_color1 text-palette_color2 rounded-b-md"
                                    : "text-palette_color1",
                                  "block px-4 py-2 text-sm font-robo "
                                )}
                                onClick={() => setDeleteMessageAlert(true)}
                                // onClick={async (e) => {
                                //   e.preventDefault();
                                //   await deleteMessage(props.message._id);
                                // }}
                              >
                                Delete Message
                              </a>
                            )}
                          </Menu.Item>
                        )}
                      </Menu.Items>
                    </Transition>
                  </Menu>
                </div>
              )}

              <text
                className={classNames(
                  props.message.senderId !==
                    backendService.getLoggedInUser()["_id"]
                    ? "bg-gray-100 text-primary  border-[1px] border-gray-100  py-1 "
                    : "bg-palette_color1 text-palette_color2  py-1  border-[1px] border-palette_color1  ",
                  "rounded-md flex  items-center  h-auto  w-auto min-h-[50px] min-w-auto w-full max-w-sm  break-all  text-sm text-primary font-light   drop-shadow-sm hover:drop-shadow "
                )}
              >
                {props.userInfo.state === "grouped" &&
                props.message.senderId !==
                  backendService.getLoggedInUser()["_id"] ? (
                  <div className=" flex-col px-1  roundedlg auto-rows-max">
                    <div className="text-palette_color1 text-sm col-span-2 pb-1 rounded-t-lg font-robo font-semibold  ">
                      {findUserById(props.message.senderId)?.username}
                    </div>

                    <div className="flex-col min-w-[80px] ">
                      <div
                        className={classNames(
                          props.message.senderId !==
                            backendService.getLoggedInUser()["_id"]
                            ? "flex justify-start bg-palette_color2  p-1 rounded-md "
                            : "flex justify-end px-1",
                          ""
                        )}
                      >
                        {props.message.content}
                      </div>
                      <div
                        className={classNames(
                          props.message.senderId !==
                            backendService.getLoggedInUser()["_id"]
                            ? "flex justify-end "
                            : "flex justify-end",
                          ""
                        )}
                      >
                        <text
                          className={classNames(
                            props.message.senderId !==
                              backendService.getLoggedInUser()["_id"]
                              ? "justify-self-start text-primary font-robo"
                              : "justify-self-end text-primary font-robo",
                            "text-[.68rem] h-[15px]"
                          )}
                        >
                          {props.message?.status === "sending" ? (
                            "Sending"
                          ) : (
                            <h3 className="  text-[10px] antialiased font-robo">
                              {/* <TimeAgo datetime={props.message.createdAt} /> */}

                              {moment(props.message.createdAt).format("LL") ===
                              moment(new Date()).format("LL")
                                ? moment(props.message.createdAt).format("LT")
                                : moment(props.message.createdAt).fromNow()}
                            </h3>
                          )}
                        </text>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="flex-col px-1 min-w-[80px]">
                    <div
                      className={classNames(
                        props.message.senderId !==
                          backendService.getLoggedInUser()["_id"]
                          ? "flex justify-start px-1 "
                          : "flex justify-start px-1",
                        ""
                      )}
                    >
                      {props.message.content}
                    </div>
                    <div
                      className={classNames(
                        props.message.senderId !==
                          backendService.getLoggedInUser()["_id"]
                          ? "flex justify-end "
                          : "flex justify-end",
                        ""
                      )}
                    >
                      <text
                        className={classNames(
                          props.message.senderId !==
                            backendService.getLoggedInUser()["_id"]
                            ? "justify-self-start text-primary font-robo"
                            : "justify-self-end text-primary font-robo",
                          "text-[.68rem] h-[15px]"
                        )}
                      >
                        {props.message?.status === "sending" ? (
                          "Sending"
                        ) : (
                          <h3 className="  text-[10px] antialiased font-robo">
                            {/* <TimeAgo datetime={props.message.createdAt} /> */}

                            {moment(props.message.createdAt).format("LL") ===
                            moment(new Date()).format("LL")
                              ? moment(props.message.createdAt).format("LT")
                              : moment(props.message.createdAt).fromNow()}
                          </h3>
                        )}
                      </text>
                    </div>
                  </div>
                )}
              </text>
            </div>
          </div>
        ) : props.message.contentType.includes("code") ? (
          <div className="grid grid-flow-row auto-rows-auto relative">
            <div
              className={classNames(
                props.message.senderId !==
                  backendService.getLoggedInUser()["_id"]
                  ? "flex-row-reverse"
                  : null,
                "flex justify-between items-center"
              )}
              onMouseEnter={() => setChevronIcon(true)}
              onMouseLeave={() => setChevronIcon(false)}
            >
              {chevronIcon && (
                <div className="mx-3 relative flex items-center justify-center">
                  <Menu
                    as="div"
                    className="absolute items-center justify-center inline-block text-left z-10"
                  >
                    <Menu.Button>
                      <ChevronDownIcon
                        className="h-6 w-6 mx-2 text-palette_color1 cursor-pointer"
                        aria-hidden="true"
                      />
                    </Menu.Button>

                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items
                        className={classNames(
                          props.message.senderId !==
                            backendService.getLoggedInUser()["_id"]
                            ? "left-0"
                            : "right-0",

                          "origin-top-center absolute  bottom-[30px] mt-1 w-48 rounded-md shadow-sm shadow-black bg-palette_color2 focus:outline-none z-10"
                        )}
                      >
                        <Menu.Item>
                          {({ active }) => (
                            <a
                              href="#"
                              className={classNames(
                                active
                                  ? "bg-palette_color1 text-palette_color2 rounded-t-md"
                                  : "text-palette_color1",
                                "block px-4 py-2 text-sm font-robo "
                              )}
                              onClick={() => {
                                setCurrentMessage(props.message._id);
                                setForwardMessage(true);
                              }}
                            >
                              Forward Message
                            </a>
                          )}
                        </Menu.Item>
                        {props.message.senderId !==
                        backendService.getLoggedInUser()["_id"] ? null : (
                          <Menu.Item>
                            {({ active }) => (
                              <a
                                href="#"
                                className={classNames(
                                  active
                                    ? "bg-palette_color1 text-palette_color2 rounded-t-md"
                                    : "text-palette_color1",
                                  "block px-4 py-2 text-sm font-robo "
                                )}
                                onClick={() => setDeleteMessageAlert(true)}
                                // onClick={async (e) => {
                                //   e.preventDefault();
                                //   await deleteMessage(props.message._id);
                                // }}
                              >
                                Delete Message
                              </a>
                            )}
                          </Menu.Item>
                        )}
                      </Menu.Items>
                    </Transition>
                  </Menu>
                </div>
              )}
              <div
                className={classNames(
                  props.message.senderId !==
                    backendService.getLoggedInUser()["_id"]
                    ? "rounded-lg bg-gray-100   "
                    : "rounded-lg bg-palette_color1 ",
                  "object-contain h-auto w-full max-w-md sm:max-w-lg md:max-w-xl items-center  drop-shadow-sm hover:drop-shadow"
                )}
              >
                {props.userInfo.state === "grouped" &&
                props.message.senderId !==
                  backendService.getLoggedInUser()["_id"] ? (
                  <div className=" grid grid-rows-2  auto-rows-max ">
                    <div className=" text-sm font-semibold row-span-2 pt-2 px-2 font-robo rounded-t-lg text-palette_color1 bg-gray-100   ">
                      {findUserById(props.message.senderId)?.username}
                    </div>
                    <div className="bg-palette_color2 rounded-md p-1 mx-1">
                      <div className=" w-auto relative ">
                        <EyeIcon
                          className="h-5 w-5 absolute top-[12px] right-10 text-gray-700 hover:opacity-60 z-10"
                          onClick={() => {
                            setCodeData({
                              script: props.message.content,
                              language: props.message.contentType.split("/")[1],
                            });
                            setOpenViewCodeModal(true);
                          }}
                        />
                        <CopyBlock
                          language={props.message.contentType.split("/")[1]}
                          text={props.message.content}
                          theme={monoBlue}
                          codeBlock
                          wrapLines={true}
                          showLineNumbers={true}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="relative w-auto px-1  pt-2">
                    <EyeIcon
                      className="h-5 w-5 absolute top-5 right-10 text-gray-700 hover:opacity-60 z-10"
                      onClick={() => {
                        setCodeData({
                          script: props.message.content,
                          language: props.message.contentType.split("/")[1],
                        });
                        setOpenViewCodeModal(true);
                      }}
                    />
                    <CopyBlock
                      language={props.message.contentType.split("/")[1]}
                      text={props.message.content}
                      theme={monoBlue}
                      codeBlock
                      wrapLines={true}
                      showLineNumbers={true}
                    />
                  </div>
                )}

                <div
                  className={classNames(
                    props.message.senderId !==
                      backendService.getLoggedInUser()["_id"]
                      ? "bg-gray-100  "
                      : "bg-palette_color1 rounded-b-lg",
                    "flex items-center "
                  )}
                >
                  <div className="flex w-[80%]">
                    <div className="flex m-2 ">
                      <button
                        className="bg-orange-500 border-[1px] border-orange-500 mt-1 hover:bg-palette_color2 text-white hover:text-orange-500  font-robo uppercase text-md  px-8 py-1 rounded shadow-sm hover:border hover:border-orange-500  ease-linear transition-all duration-500"
                        onClick={() => setEditCode(true)}
                      >
                        Edit
                      </button>
                    </div>
                    <div className="flex m-2">
                      <button
                        className="bg-palette_color4 border-[1px] border-palette_color4 mt-1 hover:bg-palette_color2 text-white hover:text-palette_color4   font-robo uppercase text-md  px-8 py-1 rounded shadow-sm hover:border hover:border-palette_color4  ease-linear transition-all duration-500"
                        onClick={() => {
                          setCodeData({
                            script: props.message.content,
                            language: props.message.contentType.split("/")[2],
                          });
                          if (
                            props.message.contentType.split("/")[2] ===
                            "Not Supported"
                          ) {
                            toast.error("This language is not supported");
                          } else {
                            setShowCodeRunModal(true);
                          }
                        }}
                      >
                        Run
                      </button>
                    </div>
                  </div>
                  <div
                    className={classNames(
                      props.message.senderId !==
                        backendService.getLoggedInUser()["_id"]
                        ? "flex justify-end "
                        : "flex justify-end",
                      " w-[20%] pr-2 "
                    )}
                  >
                    <text
                      className={classNames(
                        props.message.senderId !==
                          backendService.getLoggedInUser()["_id"]
                          ? "justify-self-start text-primary font-robo"
                          : "justify-self-end text-primary font-robo",
                        "text-[.68rem] h-[15px]"
                      )}
                    >
                      {props.message?.status === "sending" ? (
                        "Sending"
                      ) : (
                        <h3 className="  text-[10px] antialiased font-robo">
                          {/* <TimeAgo datetime={props.message.createdAt} /> */}

                          {moment(props.message.createdAt).format("LL") ===
                          moment(new Date()).format("LL")
                            ? moment(props.message.createdAt).format("LT")
                            : moment(props.message.createdAt).fromNow()}
                        </h3>
                      )}
                    </text>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : props.message.contentType === "video" ? (
          <div
            className="grid grid-flow-row auto-rows-auto relative"
            onMouseEnter={() => setChevronIcon(true)}
            onMouseLeave={() => setChevronIcon(false)}
          >
            <div
              className={classNames(
                props.message.senderId !==
                  backendService.getLoggedInUser()["_id"]
                  ? "flex-row-reverse"
                  : null,
                "flex justify-center items-center"
              )}
            >
              {chevronIcon && (
                <div className="relative mx-3 flex items-center justify-center">
                  <Menu
                    as="div"
                    className="absolute items-center justify-center inline-block text-left z-10"
                  >
                    <Menu.Button>
                      <ChevronDownIcon
                        className="h-6 w-6 mx-2 text-palette_color1 cursor-pointer"
                        aria-hidden="true"
                      />
                    </Menu.Button>

                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items
                        className={classNames(
                          props.message.senderId !==
                            backendService.getLoggedInUser()["_id"]
                            ? "left-0"
                            : "right-0",

                          "origin-top-center absolute  bottom-[30px] mt-1 w-48 rounded-md shadow-lg bg-palette_color2 focus:outline-none z-10"
                        )}
                      >
                        <Menu.Item>
                          {({ active }) => (
                            <a
                              href="#"
                              className={classNames(
                                active
                                  ? "bg-palette_color1 text-palette_color2 rounded-t-md"
                                  : "text-palette_color1",
                                "block px-4 py-2 text-sm font-robo "
                              )}
                              onClick={() => {
                                setCurrentMessage(props.message._id);
                                setForwardMessage(true);
                              }}
                            >
                              Forward Message
                            </a>
                          )}
                        </Menu.Item>
                        {props.message.senderId !==
                        backendService.getLoggedInUser()["_id"] ? null : (
                          <Menu.Item>
                            {({ active }) => (
                              <a
                                href="#"
                                className={classNames(
                                  active
                                    ? "bg-palette_color1 text-palette_color2 rounded-b-md"
                                    : "text-palette_color1",
                                  "block px-4 py-2 text-sm font-robo "
                                )}
                                onClick={() => setDeleteMessageAlert(true)}
                                // onClick={async (e) => {
                                //   e.preventDefault();
                                //   await deleteMessage(props.message._id);
                                // }}
                              >
                                Delete Message
                              </a>
                            )}
                          </Menu.Item>
                        )}
                      </Menu.Items>
                    </Transition>
                  </Menu>
                </div>
              )}
              {props.userInfo.state === "grouped" &&
              props.message.senderId !==
                backendService.getLoggedInUser()["_id"] ? (
                <div className="flex relative bg-gray-100  rounded-lg">
                  <div className=" grid grid-rows-2  auto-rows-max ">
                    <div className="text-palette_color1 font-semibold  rounded-t-lg  text-sm row-span-2 px-2 font-robo ">
                      {findUserById(props.message.senderId)?.username}
                    </div>
                    <div className=" px-2 py-1 ">
                      <div className="aspect-video w-full max-w-md sm:max-w-lg md:max-w-xl bg-palette_color2 rounded-md">
                        <ReactPlayer
                          width="100%"
                          height="100%"
                          pip={false}
                          controls={true}
                          url={props.message?.data.filePath}
                        />
                      </div>
                      <div
                        className={classNames(
                          props.message.senderId !==
                            backendService.getLoggedInUser()["_id"]
                            ? "flex justify-end "
                            : "flex justify-end",
                          ""
                        )}
                      >
                        <text
                          className={classNames(
                            props.message.senderId !==
                              backendService.getLoggedInUser()["_id"]
                              ? "justify-self-start text-primary font-robo"
                              : "justify-self-end text-primary font-robo",
                            "text-[.68rem] h-[15px]"
                          )}
                        >
                          {props.message?.status === "sending" ? (
                            "Sending"
                          ) : (
                            <h3 className="  text-[10px] antialiased font-robo">
                              {/* <TimeAgo datetime={props.message.createdAt} /> */}

                              {moment(props.message.createdAt).format("LL") ===
                              moment(new Date()).format("LL")
                                ? moment(props.message.createdAt).format("LT")
                                : moment(props.message.createdAt).fromNow()}
                            </h3>
                          )}
                        </text>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className={classNames(
                    props.message.senderId !==
                      backendService.getLoggedInUser()["_id"]
                      ? "bg-gray-100 text-primary  "
                      : "bg-palette_color1 text-palette_color2",
                    "rounded-lg pt-[15px] px-2 "
                  )}
                >
                  <div className="aspect-video w-full max-w-md sm:max-w-lg md:max-w-xl">
                    <ReactPlayer
                      width="100%"
                      height="100%"
                      pip={false}
                      controls={true}
                      url={props.message?.data.filePath}
                    />
                  </div>
                  <div
                    className={classNames(
                      props.message.senderId !==
                        backendService.getLoggedInUser()["_id"]
                        ? "flex justify-end "
                        : "flex justify-end text-pa",
                      "pr-1 pb-1"
                    )}
                  >
                    <text
                      className={classNames(
                        props.message.senderId !==
                          backendService.getLoggedInUser()["_id"]
                          ? "justify-self-start text-primary font-robo"
                          : "justify-self-end text-primary font-robo",
                        "text-[.68rem] h-[15px]"
                      )}
                    >
                      {props.message?.status === "sending" ? (
                        "Sending"
                      ) : (
                        <h3 className="  text-[10px] antialiased font-robo">
                          {/* <TimeAgo datetime={props.message.createdAt} /> */}

                          {moment(props.message.createdAt).format("LL") ===
                          moment(new Date()).format("LL")
                            ? moment(props.message.createdAt).format("LT")
                            : moment(props.message.createdAt).fromNow()}
                        </h3>
                      )}
                    </text>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : props.message.contentType === "file" ? (
          <div className="grid grid-flow-row auto-rows-auto relative">
            <div
              className={classNames(
                props.message.senderId !==
                  backendService.getLoggedInUser()["_id"]
                  ? "flex-row-reverse"
                  : null,
                "flex justify-between items-center"
              )}
              onMouseEnter={() => setChevronIcon(true)}
              onMouseLeave={() => setChevronIcon(false)}
            >
              {chevronIcon && (
                <div className="mx-3 relative flex items-center justify-center">
                  <Menu
                    as="div"
                    className="absolute items-center justify-center inline-block text-left z-10"
                  >
                    <Menu.Button>
                      <ChevronDownIcon
                        className="h-6 w-6 mx-2 text-palette_color1 cursor-pointer"
                        aria-hidden="true"
                      />
                    </Menu.Button>

                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items
                        className={classNames(
                          props.message.senderId !==
                            backendService.getLoggedInUser()["_id"]
                            ? "left-0"
                            : "right-0",

                          "origin-top-center absolute  bottom-[30px] mt-1 w-48 rounded-md shadow-lg bg-palette_color2 focus:outline-none z-10"
                        )}
                      >
                        <Menu.Item>
                          {({ active }) => (
                            <a
                              href="#"
                              className={classNames(
                                active
                                  ? "bg-palette_color1 text-palette_color2 rounded-t-md"
                                  : "text-palette_color1",
                                "block px-4 py-2 text-sm font-robo "
                              )}
                              onClick={() => {
                                setCurrentMessage(props.message._id);
                                setForwardMessage(true);
                              }}
                            >
                              Forward Message
                            </a>
                          )}
                        </Menu.Item>
                        {props.message.senderId !==
                        backendService.getLoggedInUser()["_id"] ? null : (
                          <Menu.Item>
                            {({ active }) => (
                              <a
                                href="#"
                                className={classNames(
                                  active
                                    ? "bg-palette_color1 text-palette_color2 rounded-b-md"
                                    : "text-palette_color1",
                                  "block px-4 py-2 text-sm font-robo "
                                )}
                                onClick={() => setDeleteMessageAlert(true)}
                                // onClick={async (e) => {
                                //   e.preventDefault();
                                //   await deleteMessage(props.message._id);
                                // }}
                              >
                                Delete Message
                              </a>
                            )}
                          </Menu.Item>
                        )}
                      </Menu.Items>
                    </Transition>
                  </Menu>
                </div>
              )}
              <div
                className={classNames(
                  props.message.senderId !==
                    backendService.getLoggedInUser()["_id"]
                    ? "  rounded-lg bg-gray-100  text-palette_color1 "
                    : "rounded-lg bg-palette_color1  text-palette_color2 ",
                  "object-contain h-auto w-full max-w-md sm:max-w-lg md:max-w-xl items-center  p-1  "
                )}
              >
                {props.userInfo.state === "grouped" &&
                props.message.senderId !==
                  backendService.getLoggedInUser()["_id"] ? (
                  <div className="flex   ">
                    {" "}
                    <div className=" flex-col w-full  ">
                      <div className="text-palette_color1  rounded-t-lg   font-robo text-sm font-semibold pb-1 px-1">
                        {findUserById(props.message.senderId)?.username}
                      </div>
                      <div>
                        {" "}
                        {props.message.data !== undefined ? (
                          <div className="flex justify-start items-center w-full rounded-md bg-palette_color2">
                            {props.message?.data?.filePath ? (
                              <div className="flex w-[80%] justify-start items-center ">
                                <div className="flex justify-center items-center  w-[15%] ">
                                  {!isInProgress ? (
                                    <div className="flex justify-center items-center w-[20%]">
                                      <div
                                        onClick={() =>
                                          download(
                                            props.message?.data?.filePath,
                                            props.message?.data?.fileOGName
                                          )
                                        }
                                        className="flex justify-center items-center h-7 w-7 text-primary"
                                      >
                                        <DownloadIcon className="h-5 w-5 cursor-pointer" />
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      <div className="flex flex-row relative">
                                        <div className="flex justify-center items-center">
                                          <div className="flex justify-center items-center">
                                            <CircularProgressbar
                                              className="h-7 w-7 rounded-full "
                                              value={percentage}
                                              strokeWidth={11}
                                              styles={buildStyles({
                                                // pathColor: "turquoise",
                                                // trailColor: "gold",
                                                textSize: "20px",
                                              })}
                                              //text={`${percentage}%`}
                                            />
                                          </div>
                                          <div
                                            className="flex justify-center items-center absolute"
                                            onClick={() => cancel()}
                                          >
                                            <XIcon className="h-5 w-5 text-palette_color1 cursor-pointer" />
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>
                                <div className=" flex justify-between items-center w-[15%]">
                                  {isExtensionCodeFile(
                                    props.message.data?.fileExtension
                                  ) && (
                                    <>
                                      <button
                                        className="  text-palette_color1    uppercase   hover:opacity-60  rounded    ease-linear transition-all duration-500"
                                        onClick={async () => {
                                          const blobObj = await urlToBlob(
                                            props.message?.data?.filePath
                                          );
                                          const dataString = await blobToString(
                                            blobObj
                                          );

                                          setCodeData({
                                            script: dataString,
                                            language:
                                              getCompilerCodeByExtension(
                                                props.message.data
                                                  ?.fileExtension
                                              ).CompilerCode,
                                          });
                                          if (
                                            getCompilerCodeByExtension(
                                              props.message.data
                                                ?.fileExtension
                                            ).CompilerCode ===
                                            "Not Supported"
                                          ) {
                                            toast.error("This language is not supported");
                                          } else {
                                            setShowCodeRunModal(true);
                                          }
                                      
                                        }}
                                      >
                                        <PlayIcon className="w-5 h-5" />
                                      </button>
                                      <button
                                        className="  text-palette_color1    uppercase   hover:opacity-60  rounded    ease-linear transition-all duration-500"
                                        onClick={async () => {
                                          const blobObj = await urlToBlob(
                                            props.message?.data?.filePath
                                          );
                                          const dataString = await blobToString(
                                            blobObj
                                          );

                                          setCodeData({
                                            script: dataString,
                                            language:
                                              getCompilerCodeByExtension(
                                                props.message.data
                                                  ?.fileExtension
                                              ).LanguageCode,
                                          });
                                          setOpenViewCodeModal(true);
                                        }}
                                      >
                                        <EyeIcon className="h-5 w-5 " />
                                      </button>
                                    </>
                                  )}
                                </div>
                                <div className="flex justify-start items-center pl-2  w-[70%] ">
                                  <Icon
                                    {...getFileTypeIconProps({
                                      extension:
                                        props.message.data?.fileExtension,
                                    })}
                                    className="h-5 w-5 cursor-pointer "
                                  />
                                  <p className="text-sm font-robo text-primary pl-2 ">
                                    {truncate(
                                      props.message?.data?.fileOGName,
                                      20
                                    )}
                                  </p>
                                </div>
                              </div>
                            ) : (
                              <div className="w-full flex justify-center">
                                File not found
                              </div>
                            )}
                            <div
                              className={classNames(
                                props.message.senderId !==
                                  backendService.getLoggedInUser()["_id"]
                                  ? "flex text-black "
                                  : "flex ",
                                "w-[20%]"
                              )}
                            >
                              <text
                                className={classNames(
                                  props.message.senderId !==
                                    backendService.getLoggedInUser()["_id"]
                                    ? "justify-self-start  font-robo"
                                    : "justify-self-end  font-robo",
                                  "text-[.68rem] h-[15px]"
                                )}
                              >
                                {props.message?.status === "sending" ? (
                                  "Sending"
                                ) : (
                                  <h3 className="  text-[10px] antialiased font-robo">
                                    {/* <TimeAgo datetime={props.message.createdAt} /> */}

                                    {moment(props.message.createdAt).format(
                                      "LL"
                                    ) === moment(new Date()).format("LL")
                                      ? moment(props.message.createdAt).format(
                                          "LT"
                                        )
                                      : moment(
                                          props.message.createdAt
                                        ).fromNow()}
                                  </h3>
                                )}
                              </text>
                            </div>
                          </div>
                        ) : (
                          <div className="grid grid-cols-2 w-full justify-start items-center mx-5 ">
                            {/* <TailSpin stroke="#000000" className="my-2 mx-2 right-0 " /> */}
                            <ClockLoader
                              size={30}
                              color={"#ffffff"}
                              loading={true}
                            />
                            <p className="text-sm flex justify-start items-center antialiased  font-robo ">
                              {truncate(props.message.filename, 15)}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : props.message.data !== undefined ? (
                  <div className="flex justify-start items-center  ">
                    {props.message?.data?.filePath ? (
                      <div className="flex  justify-start items-center w-[80%] ">
                        <div className="justify-center items-center  flex w-[15%] ">
                          {!isInProgress ? (
                            <div className="flex justify-center items-center w-[20%]">
                              <div
                                onClick={() =>
                                  download(
                                    props.message?.data?.filePath,
                                    props.message?.data?.fileOGName
                                  )
                                }
                                className="flex justify-center items-center h-7 w-7 text-primary"
                              >
                                <DownloadIcon className="h-5 w-5 cursor-pointer" />
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="flex flex-row relative">
                                <div className="flex justify-center items-center">
                                  <div className="flex justify-center items-center">
                                    <CircularProgressbar
                                      className="h-7 w-7 rounded-full "
                                      value={percentage}
                                      strokeWidth={11}
                                      styles={buildStyles({
                                        // pathColor: "turquoise",
                                        // trailColor: "gold",
                                        textSize: "20px",
                                      })}
                                      //text={`${percentage}%`}
                                    />
                                  </div>
                                  <div
                                    className="flex justify-center items-center absolute"
                                    onClick={() => cancel()}
                                  >
                                    <XIcon className="h-5 w-5 text-palette_color2 cursor-pointer" />
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                        <div className="flex justify-between items-center w-[15%]">
                          {isExtensionCodeFile(
                            props.message.data?.fileExtension
                          ) && (
                            <>
                              <button
                                className={classNames(
                                  props.message.senderId !==
                                    backendService.getLoggedInUser()["_id"]
                                    ? " text-palette_color1 "
                                    : " text-palette_color2 ",
                                  "   hover:opacity-60     ease-linear transition-all duration-500"
                                )}
                                onClick={async () => {
                                  const blobObj = await urlToBlob(
                                    props.message?.data?.filePath
                                  );
                                  const dataString = await blobToString(
                                    blobObj
                                  );

                                  setCodeData({
                                    script: dataString,
                                    language: getCompilerCodeByExtension(
                                      props.message.data?.fileExtension
                                    ).CompilerCode,
                                  });
                                  if (
                                    getCompilerCodeByExtension(
                                      props.message.data
                                        ?.fileExtension
                                    ).CompilerCode ===
                                    "Not Supported"
                                  ) {
                                    toast.error("This language is not supported");
                                  } else {
                                    setShowCodeRunModal(true);
                                  }
                               
                                }}
                              >
                                <PlayIcon className="w-5 h-5" />
                              </button>
                              <button
                                className={classNames(
                                  props.message.senderId !==
                                    backendService.getLoggedInUser()["_id"]
                                    ? " text-palette_color1 "
                                    : " text-palette_color2 ",
                                  "   hover:opacity-60     ease-linear transition-all duration-500"
                                )}
                                onClick={async () => {
                                  const blobObj = await urlToBlob(
                                    props.message?.data?.filePath
                                  );
                                  const dataString = await blobToString(
                                    blobObj
                                  );

                                  setCodeData({
                                    script: dataString,
                                    language: getCompilerCodeByExtension(
                                      props.message.data?.fileExtension
                                    ).LanguageCode,
                                  });
                                  setOpenViewCodeModal(true);
                                }}
                              >
                                <EyeIcon className="h-5 w-5 " />
                              </button>
                            </>
                          )}
                        </div>
                        <div className="flex justify-start items-center pr-2 pl-2 w-[70%]">
                          <Icon
                            {...getFileTypeIconProps({
                              extension: props.message.data?.fileExtension,
                            })}
                            className={classNames(
                              props.message.senderId !==
                                backendService.getLoggedInUser()["_id"]
                                ? " text-palette_color1 "
                                : " text-palette_color2 ",
                              "h-6 w-6"
                            )}
                          />
                          <p className="text-sm font-bold font-robo pl-2">
                            {truncate(props.message?.data?.fileOGName, 20)}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <div className="w-full flex justify-center">
                        File not found
                      </div>
                    )}
                    <div
                      className={classNames(
                        props.message.senderId !==
                          backendService.getLoggedInUser()["_id"]
                          ? "flex  justify-center text-black "
                          : "flex  justify-center",
                        "flex h-full items-center w-[20%]"
                      )}
                    >
                      <text
                        className={classNames(
                          props.message.senderId !==
                            backendService.getLoggedInUser()["_id"]
                            ? "justify-self-start font-robo"
                            : "justify-self-end  font-robo",
                          "text-[.68rem] h-[15px]"
                        )}
                      >
                        {props.message?.status === "sending" ? (
                          "Sending"
                        ) : (
                          <h3 className="  text-[10px] antialiased font-robo">
                            {/* <TimeAgo datetime={props.message.createdAt} /> */}

                            {moment(props.message.createdAt).format("LL") ===
                            moment(new Date()).format("LL")
                              ? moment(props.message.createdAt).format("LT")
                              : moment(props.message.createdAt).fromNow()}
                          </h3>
                        )}
                      </text>
                    </div>
                  </div>
                ) : (
                  <div className="grid grid-cols-2 w-full justify-start items-center mx-5 ">
                    {/* <TailSpin stroke="#000000" className="my-2 mx-2 right-0 " /> */}
                    <ClockLoader size={30} color={"#fff"} loading={true} />
                    <p className="text-sm flex justify-start items-center font-bold font-robo">
                      {truncate(props.message.filename, 15)}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : props.message.contentType === "audio" ? (
          <div className="grid grid-flow-row auto-rows-auto">
            <div
              className="object-contain h-auto w-auto items-center  text-lg text-header_text  drop-shadow-sm hover:drop-shadow"
              onMouseEnter={() => setChevronIcon(true)}
              onMouseLeave={() => setChevronIcon(false)}
            >
              {/* <AudioPlayer
              src={props.message.data.filePath}
              showJumpControls={false}
              customVolumeControls={[]}
              customAdditionalControls={[]}
              customProgressBarSection={[
                RHAP_UI.PROGRESS_BAR,
                RHAP_UI.CURRENT_LEFT_TIME,
              ]}
              layout="horizontal-reverse"
              customIcons={{ play: <PlayIcon className="bg-color-black" /> }}
            /> */}
              <div
                className={classNames(
                  props.message.senderId !==
                    backendService.getLoggedInUser()["_id"]
                    ? "flex-row-reverse"
                    : null,
                  "flex justify-center items-center"
                )}
              >
                {chevronIcon && (
                  <div
                    className={classNames(
                      props.message.senderId !==
                        backendService.getLoggedInUser()["_id"]
                        ? "justify-start"
                        : "justify-end",
                      "flex items-center"
                    )}
                  >
                    <Menu
                      as="div"
                      className="absolute items-center justify-center inline-block text-left"
                    >
                      <Menu.Button>
                        <ChevronDownIcon
                          className="h-6 w-6 mx-2 text-palette_color1 cursor-pointer"
                          aria-hidden="true"
                        />
                      </Menu.Button>

                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items
                          className={classNames(
                            props.message.senderId !==
                              backendService.getLoggedInUser()["_id"]
                              ? "left-0"
                              : "left-[-100px]",

                            "origin-top-center absolute  bottom-[30px] mt-1 w-48 rounded-md shadow-lg bg-palette_color2 focus:outline-none z-10"
                          )}
                        >
                          <Menu.Item>
                            {({ active }) => (
                              <a
                                href="#"
                                className={classNames(
                                  active
                                    ? "bg-palette_color1 text-palette_color2 rounded-t-md"
                                    : "text-palette_color1",
                                  "block px-4 py-2 text-sm font-robo "
                                )}
                                onClick={() => {
                                  setCurrentMessage(props.message._id);
                                  setForwardMessage(true);
                                }}
                              >
                                Forward Message
                              </a>
                            )}
                          </Menu.Item>
                          {props.message.senderId !==
                          backendService.getLoggedInUser()["_id"] ? null : (
                            <Menu.Item>
                              {({ active }) => (
                                <a
                                  href="#"
                                  className={classNames(
                                    active
                                      ? "bg-palette_color1 text-palette_color2 rounded-b-md"
                                      : "text-palette_color1",
                                    "block px-4 py-2 text-sm font-robo "
                                  )}
                                  onClick={() => setDeleteMessageAlert(true)}
                                  // onClick={async (e) => {
                                  //   e.preventDefault();
                                  //   await deleteMessage(props.message._id);
                                  // }}
                                >
                                  Delete Message
                                </a>
                              )}
                            </Menu.Item>
                          )}
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  </div>
                )}
                {props.userInfo.state === "grouped" &&
                props.message.senderId !==
                  backendService.getLoggedInUser()["_id"] ? (
                  <div className="flex bg-gray-100    rounded-lg">
                    <div className=" grid grid-rows-2  auto-rows-max">
                      <div className="text-palette_color1 font-semibold   rounded-t-lg   text-sm row-span-2 px-3 ">
                        {findUserById(props.message.senderId)?.username}
                      </div>
                      <div className="px-2 ">
                        <div className="bg-palette_color2 p-2 rounded-md">
                          <audio preload="auto" controls color="#525252">
                            <source src={props.message?.data.filePath} />
                          </audio>
                        </div>
                        <div
                          className={classNames(
                            props.message.senderId !==
                              backendService.getLoggedInUser()["_id"]
                              ? "flex justify-end text-black"
                              : "flex justify-end text-palette_color2",
                            ""
                          )}
                        >
                          <text
                            className={classNames(
                              props.message.senderId !==
                                backendService.getLoggedInUser()["_id"]
                                ? "justify-self-start text-primary font-robo"
                                : "justify-self-end text-primary font-robo",
                              ""
                            )}
                          >
                            {props.message?.status === "sending" ? (
                              "Sending"
                            ) : (
                              <h3 className="  text-[10px] antialiased font-robo">
                                {/* <TimeAgo datetime={props.message.createdAt} /> */}

                                {moment(props.message.createdAt).format(
                                  "LL"
                                ) === moment(new Date()).format("LL")
                                  ? moment(props.message.createdAt).format("LT")
                                  : moment(props.message.createdAt).fromNow()}
                              </h3>
                            )}
                          </text>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    className={classNames(
                      props.message.senderId !==
                        backendService.getLoggedInUser()["_id"]
                        ? " bg-gray-100 text-black"
                        : " bg-palette_color1 text-palette_color2",
                      "h-full flex-col  px-2 pt-2  rounded-lg "
                    )}
                  >
                    <audio preload="auto" controls color="#525252">
                      <source src={props.message?.data.filePath} />
                    </audio>
                    <div
                      className={classNames(
                        props.message.senderId !==
                          backendService.getLoggedInUser()["_id"]
                          ? "flex justify-end text-black"
                          : "flex justify-end text-palette_color2",
                        "h-full"
                      )}
                    >
                      <text
                        className={classNames(
                          props.message.senderId !==
                            backendService.getLoggedInUser()["_id"]
                            ? " text-primary font-robo"
                            : " text-primary font-robo",
                          " h-[15px] flex items-center"
                        )}
                      >
                        {props.message?.status === "sending" ? (
                          "Sending"
                        ) : (
                          <h3 className="  text-[10px] antialiased font-robo">
                            {/* <TimeAgo datetime={props.message.createdAt} /> */}

                            {moment(props.message.createdAt).format("LL") ===
                            moment(new Date()).format("LL")
                              ? moment(props.message.createdAt).format("LT")
                              : moment(props.message.createdAt).fromNow()}
                          </h3>
                        )}
                      </text>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="grid grid-flow-row auto-rows-auto relative">
            <div
              className={classNames(
                props.message.senderId !==
                  backendService.getLoggedInUser()["_id"]
                  ? "flex-row-reverse"
                  : null,
                "flex justify-between items-center"
              )}
              onMouseEnter={() => setChevronIcon(true)}
              onMouseLeave={() => setChevronIcon(false)}
            >
              {chevronIcon && (
                <div className="mx-3 relative flex items-center justify-center">
                  <Menu
                    as="div"
                    className="absolute items-center justify-center inline-block text-left z-10"
                  >
                    <Menu.Button>
                      <ChevronDownIcon
                        className="h-6 w-6 mx-2 text-palette_color1 cursor-pointer"
                        aria-hidden="true"
                      />
                    </Menu.Button>

                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items
                        className={classNames(
                          props.message.senderId !==
                            backendService.getLoggedInUser()["_id"]
                            ? "left-0"
                            : "right-0",

                          "origin-top-center absolute  bottom-[30px] mt-1 w-48 rounded-md shadow-lg bg-palette_color2 focus:outline-none z-10"
                        )}
                      >
                        <Menu.Item>
                          {({ active }) => (
                            <a
                              href="#"
                              className={classNames(
                                active
                                  ? "bg-palette_color1 text-palette_color2 rounded-t-md"
                                  : "text-palette_color1",
                                "block px-4 py-2 text-sm font-robo "
                              )}
                              onClick={() => {
                                setCurrentMessage(props.message._id);
                                setForwardMessage(true);
                              }}
                            >
                              Forward Message
                            </a>
                          )}
                        </Menu.Item>
                        {props.message.senderId !==
                        backendService.getLoggedInUser()["_id"] ? null : (
                          <Menu.Item>
                            {({ active }) => (
                              <a
                                href="#"
                                className={classNames(
                                  active
                                    ? "bg-palette_color1 text-palette_color2 rounded-b-md"
                                    : "text-palette_color1",
                                  "block px-4 py-2 text-sm font-robo "
                                )}
                                onClick={() => setDeleteMessageAlert(true)}
                                // onClick={async (e) => {
                                //   e.preventDefault();
                                //   await deleteMessage(props.message._id);
                                // }}
                              >
                                Delete Message
                              </a>
                            )}
                          </Menu.Item>
                        )}
                      </Menu.Items>
                    </Transition>
                  </Menu>
                </div>
              )}
              {props.userInfo.state === "grouped" &&
              props.message.senderId !==
                backendService.getLoggedInUser()["_id"] ? (
                <div className="flex relative bg-gray-100 rounded-lg   w-auto ">
                  <div className=" grid grid-rows-2  auto-rows-min">
                    <div className="text-palette_color1  rounded-t-lg  text-sm row-span-2 px-3 font-semibold">
                      {findUserById(props.message.senderId)?.username}
                    </div>
                    <div className="px-2 py-1">
                      {" "}
                      <div className="rounded-lg bg-palette_color2 p-2 w-full max-w-xs sm:max-w-sm md:max-w-md">
                        <img
                          className={classNames(
                            props.message.senderId !==
                              backendService.getLoggedInUser()["_id"]
                              ? "  "
                              : " ",
                            "object-cover max-w-full h-auto self-center cursor-pointer"
                          )}
                          onClick={() => openImageViewer()}
                          src={optimizeURL(props.message?.data.filePath)}
                          alt="img"
                        />
                      </div>
                      <div
                        className={classNames(
                          props.message.senderId !==
                            backendService.getLoggedInUser()["_id"]
                            ? "flex justify-end "
                            : "flex justify-end",
                          ""
                        )}
                      >
                        <text
                          className={classNames(
                            props.message.senderId !==
                              backendService.getLoggedInUser()["_id"]
                              ? "justify-self-start text-primary font-robo"
                              : "justify-self-end text-primary font-robo",
                            "text-[.68rem] h-[15px]"
                          )}
                        >
                          {props.message?.status === "sending" ? (
                            "Sending"
                          ) : (
                            <h3 className="  text-[10px] antialiased font-robo">
                              {/* <TimeAgo datetime={props.message.createdAt} /> */}

                              {moment(props.message.createdAt).format("LL") ===
                              moment(new Date()).format("LL")
                                ? moment(props.message.createdAt).format("LT")
                                : moment(props.message.createdAt).fromNow()}
                            </h3>
                          )}
                        </text>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className={classNames(
                    props.message.senderId !==
                      backendService.getLoggedInUser()["_id"]
                      ? " bg-gray-100 "
                      : " bg-palette_color1 ",
                    "flex-col rounded-lg pt-2 px-1 w-full max-w-xs sm:max-w-sm md:max-w-md"
                  )}
                >
                  <img
                    className={classNames(
                      props.message.senderId !==
                        backendService.getLoggedInUser()["_id"]
                        ? " "
                        : "",
                      "object-cover max-w-full h-auto self-center items-center3 text-lg text-header_text  px-1 py-1 drop-shadow-sm hover:drop-shadow cursor-pointer"
                    )}
                    onClick={() => openImageViewer()}
                    src={optimizeURL(props.message?.data.filePath)}
                    alt="img"
                  />
                  <div
                    className={classNames(
                      props.message.senderId !==
                        backendService.getLoggedInUser()["_id"]
                        ? "flex justify-end text-black "
                        : "flex justify-end text-palette_color2 ",
                      "pr-2"
                    )}
                  >
                    <text
                      className={classNames(
                        props.message.senderId !==
                          backendService.getLoggedInUser()["_id"]
                          ? "justify-self-start text-primary font-robo"
                          : "justify-self-end text-primary font-robo",
                        "text-[.68rem] h-[15px]"
                      )}
                    >
                      {props.message?.status === "sending" ? (
                        "Sending"
                      ) : (
                        <h3 className="  text-[10px] antialiased font-robo">
                          {/* <TimeAgo datetime={props.message.createdAt} /> */}

                          {moment(props.message.createdAt).format("LL") ===
                          moment(new Date()).format("LL")
                            ? moment(props.message.createdAt).format("LT")
                            : moment(props.message.createdAt).fromNow()}
                        </h3>
                      )}
                    </text>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
export default ChatBubble;
